import { render } from "./Message.vue?vue&type=template&id=677cfe3f"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
script.render = render

export default script